import { GeckoMeasurementUnit } from 'types'

export const WORKING_UNIT_THICKNESS = GeckoMeasurementUnit.Millimeters
export const DEFAULT_THICKNESS_UNIT = GeckoMeasurementUnit.Millimeters
export const WORKING_UNIT_PRESSURE = GeckoMeasurementUnit.Megapascals
